import { render } from "./protocol.vue?vue&type=template&id=466b6830"
const script = {}
script.render = render

export default script